import { Link } from "react-router-dom";
import { LOGO_URL, COMPANY } from "@/lib/constants";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1A201A] text-[#E8ECE1] mt-24">
      <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-white rounded-xl p-2 w-14 h-14 flex items-center justify-center">
              <img src={LOGO_URL} alt="Blessing Dienstleistungen" className="max-h-10" />
            </div>
            <div>
              <div className="font-display text-lg font-semibold text-white">{COMPANY.name}</div>
              <div className="text-sm text-[#B8C1A9]">Alles rund ums Haus</div>
            </div>
          </div>
          <p className="text-sm text-[#B8C1A9] leading-relaxed max-w-md">
            Zuverlässige Objektpflege in Heitersheim und Umgebung.
            Persönlich. Sorgfältig. Auf Ihre Anforderungen zugeschnitten.
          </p>
        </div>

        <div>
          <h4 className="font-display text-white text-sm font-medium mb-4 uppercase tracking-wider">Kontakt</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#95A97A]" strokeWidth={1.5} />
              <span>{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 shrink-0 text-[#95A97A]" strokeWidth={1.5} />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors" data-testid="footer-email-link">
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 shrink-0 text-[#95A97A]" strokeWidth={1.5} />
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="hover:text-white transition-colors font-medium"
                data-testid="footer-phone-link"
              >
                {COMPANY.phone}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-white text-sm font-medium mb-4 uppercase tracking-wider">Rechtliches</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-impressum-link">
                Impressum
              </Link>
            </li>
            <li>
              <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-datenschutz-link">
                Datenschutz
              </Link>
            </li>
            <li>
              <Link to="/login" className="hover:text-white transition-colors" data-testid="footer-crm-link">
                CRM-Login
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#2E3A2E]">
        <div className="max-w-6xl mx-auto px-6 py-6 text-xs text-[#95A97A] flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} {COMPANY.name} · Inhaber {COMPANY.owner}</span>
          <span>Alles rund ums Haus – Rundum-Sorglos-Paket</span>
        </div>
      </div>
    </footer>
  );
}
